"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("./core");
if (!('PluralRules' in Intl)) {
    Object.defineProperty(Intl, 'PluralRules', {
        value: core_1.PluralRules,
        writable: true,
        enumerable: false,
        configurable: true,
    });
}
//# sourceMappingURL=polyfill.js.map